import { render, staticRenderFns } from "./Artista.vue?vue&type=template&id=46e5467a"
import script from "./Artista.vue?vue&type=script&lang=js"
export * from "./Artista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports